import {
    WeekdayHeader,
    TimesheetDataCell,
    TimesheetDataRowWrapper
} from '../../../components';

const TimesheetsDataTableHeader = () => {
    return (
        <TimesheetDataRowWrapper>
            <TimesheetDataCell sx={{ gridColumn: 'span 3' }}>
                Employee
            </TimesheetDataCell>
            <WeekdayHeader sx={{ gridColumn: 'span 8' }} />
            <TimesheetDataCell
                sx={{ gridColumn: 'span 1', textAlign: 'center' }}
            >
                Total
            </TimesheetDataCell>
        </TimesheetDataRowWrapper>
    );
};

export default TimesheetsDataTableHeader;
